import AppProvider from "providers/AppProvider";
import RootNavigation from "navigation/RootNavigation";

const App = () => (
  <AppProvider>
    <RootNavigation />
  </AppProvider>
);

export default App;
